import {
  BaseEdge,
  EdgeLabelRenderer,
  EdgeProps,
  getSmoothStepPath,
} from "@xyflow/react";

import { XIcon } from "lucide-react";
import { useFlow } from "@/lib/store";

export function ButtonEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
}: EdgeProps) {
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const { removeEdge } = useFlow();

  const onEdgeRemove = () => {
    removeEdge(id);
  };

  return (
    <>
      <BaseEdge path={edgePath} markerEnd={markerEnd} style={style} />
      <EdgeLabelRenderer>
        <div
          className="absolute pointer-events-auto nodrag nopan"
          style={{
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
          }}
        >
          <button
            onClick={onEdgeRemove}
            className="p-0.5 bg-secondary hover:bg-red-500 rounded-full text-foreground hover:text-background"
          >
            <span className="sr-only">remove edge</span>
            <XIcon size={12} />
          </button>
        </div>
      </EdgeLabelRenderer>
    </>
  );
}
